// extracted by mini-css-extract-plugin
module.exports = {"chip":"_2OBhObD5bjzZdWF1FhVmBo"};